
const SearchResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"searchKey": "string",
		"pricedItineraries": [
			{
				"provider": 0,
				"fareSourceCode": "string",
				"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				"providerName": "string",
				"providerCategory": "string",
				"providerOwner": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
				"offer": "string",
				"nonRefundable": true,
				"nationalityId": "string",
				"cityCode": 0,
				"hotel": {
					"hotelId": 0,
					"lastUpdate": "string",
					"name": "string",
					"rating": 0,
					"reviewScore": 0,
					"address": "string",
					"email": "string",
					"latitude": "string",
					"longitude": "string",
					"accommodation": 0,
					"accommodationName": "string",
					"url": "string",
					"phone": "string",
					"fax": "string",
					"description": "string",
					"instructions": "string",
					"beginTime": "string",
					"endTime": "string",
					"checkOutTime": "string",
					"checkInTime": "string",
					"mandatoryFee": "string",
					"specialInstructions": "string",
					"minAge": 0,
					"hotelImage": "string",
					"amenities": [
						"string"
					]
				},
				"hotelId": 0,
				"paymentDeadline": "string",
				"currency": "string",
				"availableRoom": 0,
				"plainTextCancellationPolicy": "string",
				"netRate": 0,
				"rooms": [
					{
						"roomTypeID": 0,
						"name": "string",
						"adultCount": 0,
						"totalTax": 0,
						"childCount": 0,
						"childAges": [
							"string"
						],
						"mealType": "string",
						"sharingBedding": true,
						"bedGroups": "string",
						"netRate": 0,
						"rateplan": 0
					}
				],
				"cancellationPolicies": [
					{
						"amount": 0,
						"fromDate": "string"
					}
				],
				"remarks": [
					"string"
				],
				"images": [
					{
						"imageUrl": "string",
						"thumbnailUrl": "string"
					}
				],
				"checkIn": "string",
				"checkOut": "string"
			}
		]
	
};
 

  export default SearchResponse;
  